import { viewJobNativeModule } from "./ViewJobNativeModule";

export function logVJUnmount(payload: {
  queryStatus: string;
  duration: number;
  url: string;
  jobKey?: string;
  mobtk?: string;
}): Promise<void> {
  const nativeModule = viewJobNativeModule();
  if (nativeModule?.logVJUnmount) {
    return nativeModule.logVJUnmount(payload);
  }
  return Promise.resolve();
}
